<script>
export default {
	props: {
		iconType: String,
		icon: String,
		iconHtml: String,
		iconImage: [Object, String],
		defaultIcon: String,
		iconAttrs: Object,
	},
	computed: {
		show() {
			if (this.iconType == 'none') return false
			if (!this.iconType || this.iconType == 'icon' || this.iconType == 'default') return !!this.icon
			if (this.iconType == 'html') return !!this.iconHtml
			if (this.iconType == 'image') return !!this.iconImage
			return !!(this.icon || this.iconHtml || this.iconImage)
		},
	},
}
</script>

<template>
	<div v-if="show">
		<v-icon v-if="!iconType || iconType == 'icon' || iconType == 'default'" v-bind="iconAttrs">{{
			icon
		}}</v-icon>
		<div v-else-if="iconType == 'html'" v-html="iconHtml"></div>
		<Media width="24px" height="24px" v-else-if="iconType == 'image'" :src="iconImage"></Media>
	</div>
</template>

